<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <p class="auto-complete-label">{{ $t('Keywords') }}</p>
        <autocomplete id="create-campaign-keywords-search-input" @submit="selectKeyword" :search="searchForKeyword" :getResultValue="() => {return ''}" :placeholder="$t('Search for a keyword.')">
          <template #result="{ result, props }">
            <li v-bind="props">
              <div class="wiki-title">
                {{ result }}
              </div>
            </li>
          </template>
        </autocomplete>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10" v-if="value.length">
      <div class="vx-col w-full">
        <div class="keywords-container pt-3 px-3">
          <template>
            <div v-for="keyword in value" :key="'keywords' + keyword" class="keyword-tag inline-block py-1 px-2 mr-3 mb-3">
              <span class="keyword mr-3">
                {{ keyword }}
              </span>
              <span class="keyword-remove cursor-pointer" @click="removeKeyword(keyword)">X</span>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="keywords-container-recommended">
          <p class="recommended-keywords-p border-black border-b-2">
            <span>
              {{ $t('Recommended Keywords') }}
            </span>
            <a id="create-campaign-keywords-show-more-less-button" class="float-right" :class="{'cursor-not-allowed text-gray-500': !value.length}" href="#" @click.prevent="value.length ? show_recommended = !show_recommended : null">
              {{ $t('Show ') }}
              {{ show_recommended ? $t('less') : $t('more') }}
            </a>
          </p>
          <template v-if="show_recommended">
            <vs-divider class="custom-divider-style" />
            <template v-if="recommended_keywords.length">
              <div v-for="keyword in recommended_keywords" :key="'keywords-' + keyword" class="keyword-recommended inline-block w-auto overflow-hidden py-1 px-2 mr-3 mb-3">
                <div class="keyword-recommended-icon mr-3 inline-block ">
                  <img v-if="!value.includes(keyword)" class="align-middle cursor-pointer" @click="addKeyword(keyword)" src="@/assets/images/campaigns/inactive-keyword.svg" alt="Inactive" />
                  <img v-if="value.includes(keyword)" class="align-middle cursor-pointer" @click="removeKeyword(keyword)" src="@/assets/images/campaigns/active-keyword.svg" alt="Active" />
                </div>
                <div :class="{'keyword-recommended-text-active': value.includes(keyword)}" class="keyword-recommended-text inline-block align-middle">
                  {{ keyword }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="inline-block py-1 px-2 mr-3 mb-3">
                {{ $t('There is no recommended keywords') }}
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  watch: {
    value: {
      handler (newVal) {
        if (!this.value.length) {
          this.show_recommended = false
        } else {
          this.show_recommended = true
        }

        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  components: {
    Autocomplete
  },
  data () {
    return {
      recommended_keywords: [],
      show_recommended: false
    }
  },
  mounted () {
    if (this.value.length) {
      this.getRecommendedKeywords(this.value[this.value.length - 1])

      this.show_recommended = true
    }
  },
  methods: {
    async searchForKeyword (input) {
      let payload = []

      if (input.length > 2) {
        const response = await window.axios.get('/recommendations/get/keywords_ml', {
          params: {
            keyword: input
          }
        })

        payload = response.data.payload
      }

      return new Promise(resolve => {
        return resolve(payload)
      })
    },
    async getRecommendedKeywords (item) {
      const response = await window.axios.get('/recommendations/get/keywords_nearest_ml', {
        params: {
          keywords: [item]
        }
      })

      this.recommended_keywords = response.data.payload
    },
    selectKeyword (item) {
      this.addKeyword(item, true)
    },
    addKeyword (item, showRecommendation = false) {
      // add to value
      if (this.value.findIndex(i => i === item) === -1) {
        this.value.push(item)
      }

      document.querySelectorAll('.open-item .vs-collapse-item--content').forEach(element => {
        element.setAttribute('style', 'max-height: auto !important')
      })

      if (showRecommendation) {
        this.getRecommendedKeywords(item)
      }
    },
    removeKeyword (keyword) {
      // remove from value
      const valueIndex = this.value.findIndex(i => i === keyword)
      if (valueIndex > -1) {
        this.value.splice(valueIndex, 1)
      }
    }
  }
}
</script>

<style lang="scss">
  .keywords-container,
  .keywords-container-recommended {
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    background: #fff;
  }

  .recommended-keywords-p {
    padding: 9.5px;
  }

  .auto-complete-label {
    font-weight: normal;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.75);
    margin-bottom: 7px;
  }

  .keywords-container .keyword-tag {
    background-color: rgba(0, 146, 215, 0.1);
    border-radius: 3px;
    color: #0092d7;
    font-size: 12px;
  }

  .keywords-container-recommended {
    margin-top: 24px;

    .keyword-recommended-text {
      color: rgba(0, 0, 0, 0.65);
      font-size: 13px;
    }

    .keyword-recommended-icon {
      color: rgba(0, 0, 0, 0.65);
      font-size: 13px;
    }

    .keyword-recommended-text-active {
      color: #0092d7;
    }
  }

  .autocomplete-input,
  .autocomplete-input:focus,
  .autocomplete-input[aria-expanded=true] {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: none;
    padding: 7px 7px 7px 48px;
    border-radius: 4px;
  }
</style>
